module.exports = __webpack_public_path__ + "static/media/Snony W850C.4adf42e1.png";